$(document).ready(function () {
  if ($('.accordion-item').length) {
    $('.accordion-item').click(function () {
      $(this).toggleClass('expanded');
    });
  }
});